import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './NewCarrier.css';
import Aux from '../../../hoc/Auxiliary/Auxiliary';
import Backdrop from '../Backdrop/Backdrop';
import personImg from '../../../assets/images/person-icon.png';
import closeImg from '../../../assets/images/close-icon.png';
import saveImg from '../../../assets/images/save-icon.png';
import Icon from '../Icon/Icon';
import ButtonIcon from '../ButtonIcon/ButtonIcon';
import Input from '../Input/Input';
import logError from '../../../store/LogError';
import axios from '../../../axios-trips';
import * as actionTypes from '../../../store/actions';

class NewCarrier extends Component {

  createInputConfig = (elementType,
    elementConfig,
    label,
    value = '',
    validation = {},
    valid = true,
    extraClass = null) => {
    return ({
      elementType: elementType,
      elementConfig: elementConfig,
      label: label,
      value: value,
      validation: validation,
      valid: valid,
      extraClass: extraClass,
      touched: false,
      errorMessage: null
    });
  }

  state = {
    loading: false,
    editing: false,
    carrierForm: {
      okpo: this.createInputConfig(
        'input',
        { type: 'text' },
        'ОКПО: ',
        '',
        { required: false },
        true),
      name: this.createInputConfig(
        'input',
        { type: 'text' },
        'Назва: ',
        '',
        { required: false },
        true),
      ls: this.createInputConfig(
        'display-only',
        { type: 'text' },
        'Особовий Рахунок: ',
        '',
        { required: false },
        true),
      lsid: this.createInputConfig(
        'input',
        { type: 'text' },
        'ID Рахунку: ',
        '',
        { required: false },
        true),
      phone: this.createInputConfig(
        'input',
        { type: 'text' },
        'Телефон: ',
        '',
        { required: false },
        true)
    },
    formIsValid: false
  }

  escFunction = (event) => {
    if (event.keyCode === 27) {
      this.props.closeCard();
    }
  }

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.carrier !== this.props.carrier) {
      if (this.props.carrier !== null && this.props.carrier.id !== undefined) {
        const updatedCarrierForm = { ...this.state.carrierForm };
        updatedCarrierForm.okpo.value = this.props.carrier.okpo;
        updatedCarrierForm.name.value = this.props.carrier.name;
        updatedCarrierForm.ls.value = this.props.carrier.name_ls;
        updatedCarrierForm.lsid.value = this.props.carrier.ls;
        updatedCarrierForm.phone.value = this.props.carrier.phone;
        if (this.props.carrier.id > 0) {
          this.setState({ editing: true, carrierForm: updatedCarrierForm });
        } else {
          this.setState({ editing: false, carrierForm: updatedCarrierForm });
        }

      } else {
        const updatedCarrierForm = { ...this.state.carrierForm };
        updatedCarrierForm.okpo.value = "";
        updatedCarrierForm.name.value = "";
        updatedCarrierForm.ls.value = "";
        updatedCarrierForm.lsid.value = "";
        updatedCarrierForm.phone.value = "";
        this.setState({ editing: false, carrierForm: updatedCarrierForm });
      }
    }
  }

  checkValidity(value, rules) {
    let isValid = true;

    if (rules.required) {
      isValid = value.trim !== '' && isValid;
    }

    if (rules.type === "email") {
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      isValid = re.test(value) && isValid;
    }

    if (rules.minLength) {
      isValid = value.length >= rules.minLength && isValid;
    }

    if (rules.maxLength) {
      isValid = value.length <= rules.maxLength && isValid;
    }

    return isValid;
  }

  getErrorMessage(value, rules) {
    let errorMessage = '';

    if (rules.required && value.trim === '') {
      errorMessage = 'Це поле обов\'язкове';
    }

    if (rules.type == 'email') {
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(value)) {
        errorMessage = 'Введіть правильний email';
      }
    }

    if (rules.minLength && value.length < rules.minLength) {
      errorMessage = 'Мінімальна довжина: ' + rules.minLength;
    }

    if (rules.maxLength && value.length > rules.maxLength) {
      errorMessage = 'Максимальна довжина: ' + rules.minLength;
    }

    return errorMessage;
  }

  inputChangedHandler = (event, elementId) => {
    const updatedCarrierForm = {
      ...this.state.carrierForm
    }
    const updatedFormElement = {
      ...updatedCarrierForm[elementId]
    }

    if ((event.target.value === '' || event.target.value === null) &&
      updatedCarrierForm[elementId].elementConfig.type === 'number') {
      event.target.value = 0;
    }
    updatedFormElement.value = event.target.value;
    updatedFormElement.touched = true;
    updatedFormElement.valid = this.checkValidity(updatedFormElement.value,
      updatedFormElement.validation);
    updatedFormElement.errorMessage = this.getErrorMessage(updatedFormElement.value,
      updatedFormElement.validation);
    updatedCarrierForm[elementId] = updatedFormElement;

    let formIsValid = true;
    for (let inputIdentifier in updatedCarrierForm) {
      formIsValid = updatedCarrierForm[inputIdentifier].valid && formIsValid;
    }

    this.setState({ carrierForm: updatedCarrierForm, formIsValid: formIsValid });
  }

  newCarrierHandler = (event) => {
    event.preventDefault();
    if (this.props.access_token === null) {
      return;
    }

    if (this.state.editing) {
      const data = {
        id: this.props.carrier.id,
        okpo: this.state.carrierForm.okpo.value,
        name: this.state.carrierForm.name.value,
        lsid: this.state.carrierForm.lsid.value,
        phone: this.state.carrierForm.phone.value
      }

      axios({
        method: 'post',
        url: '/api/v1/carriers/update',
        data: data,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.props.access_token
        },
      })
        .then(response => {
          console.log(response);
          this.props.addNotification("Перевізник був успішно оновлений.", "Success");
          this.onCarrierUpdatedHandler(response.data);
        })
        .catch(error => {
          console.log(error);
          this.setState({ loading: false });
          if (error.response) {
            logError(
              this.props.access_token,
              this.props.codeToMessage[error.response.status],
              '/api/v1/carriers/update'
            );
            this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
          }
        });
    } else {
      const data = {
        id: 0,
        okpo: this.state.carrierForm.okpo.value,
        name: this.state.carrierForm.name.value,
        lsid: this.state.carrierForm.lsid.value,
        phone: this.state.carrierForm.phone.value
      }

      axios({
        method: 'post',
        url: '/api/v1/carriers',
        data: data,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.props.access_token
        },
      })
        .then(response => {
          console.log(response);
          this.props.addNotification("Перевізник був успішно створений.", "Success");
          this.onCarrierCreatedHandler(response.data);
        })
        .catch(error => {
          console.log(error);
          this.setState({ loading: false });
          if (error.response) {
            logError(
              this.props.access_token,
              this.props.codeToMessage[error.response.status],
              '/api/v1/carriers'
            );
            this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
          }
        });
    }
  }

  onCarrierUpdatedHandler(carrier) {
    const updatedCarriers = [...this.props.carriers];
    for (let i = 0; i < updatedCarriers.length; i++) {
      if (updatedCarriers[i].id === this.props.carrier.id) {
        updatedCarriers[i] = carrier;
      }
    }
    this.props.onSetCarriers(updatedCarriers);
    this.props.onShowNewCarrier(null);

    const updatedCarrierForm = { ...this.state.carrierForm };
    updatedCarrierForm.okpo.value = "";
    updatedCarrierForm.name.value = "";
    updatedCarrierForm.ls.value = "";
    updatedCarrierForm.phone.value = "";
    this.setState({ carrierForm: updatedCarrierForm });
  }

  onCarrierCreatedHandler(carrier) {
    const updatedCarriers = [...this.props.carriers];
    updatedCarriers.push(carrier);
    this.props.onSetCarriers(updatedCarriers);
    this.props.onShowNewCarrier(null);
    const updatedCarrierForm = { ...this.state.carrierForm };
    updatedCarrierForm.okpo.value = "";
    updatedCarrierForm.name.value = "";
    updatedCarrierForm.ls.value = "";
    updatedCarrierForm.phone.value = "";
    this.setState({ carrierForm: updatedCarrierForm });
  }

  render() {
    let card = null;

    const carrierFormArray = [];
    for (let key in this.state.carrierForm) {
      carrierFormArray.push({ id: key, config: this.state.carrierForm[key] });
    }

    card = (
      <Aux>
        <div className={classes.Header}>
          <Icon iconClass={classes.CarIcon} iconSource={personImg} iconAlt='' className={classes.CardIcon} />
          <p>Новий Перевізник</p>

          <button className={classes.CloseButton} onClick={this.props.closeCard}>
            <Icon iconClass={classes.CloseIcon} iconSource={closeImg} iconAlt='' />
          </button>
          <p style={{ height: "100%" }}></p>
        </div>

        <form className={classes.NewCarrierForm} onSubmit={this.newCarrierHandler}>
          <div className={classes.Body} >
            {carrierFormArray.map(formElement => {
              return (
                <Input
                  key={formElement.id}
                  label={formElement.config.label}
                  elementType={formElement.config.elementType}
                  elementConfig={formElement.config.elementConfig}
                  value={formElement.config.value}
                  extraClass={formElement.config.extraClass}
                  extraAction={formElement.config.extraAction}
                  changed={(event) => this.inputChangedHandler(event, formElement.id)} />
              );
            })}
          </div>

          <div className={classes.Footer}>
            <ButtonIcon
              btnType='Success'
              iconClass={classes.ButtonIcon}
              iconSource={saveImg}
              iconAlt=''>ЗБЕРЕГТИ</ButtonIcon>
          </div>
        </form>
      </Aux>
    );

    return (
      <Aux>
        <Backdrop show={this.props.carrier !== null} clicked={this.props.closeCard} />
        <div
          className={classes.CardModal}
          style={{
            transform: this.props.carrier !== null ? 'translateY(0)' : 'translateY(-100vh)',
            opacity: this.props.carrier !== null ? '1' : '0'
          }}>
          {card}
        </div>
      </Aux>
    );
  }
};

const mapStateToProps = state => {
  return {
    access_token: state.access_token,
    notifications: state.notifications,
    carriers: state.carriers,
    codeToMessage: state.codeToMessage
  };
}

const mapDispatchToProps = dispatch => {
  return {
    addNotification: (notification, notificationType) => dispatch({
      type: actionTypes.ADD_NOTIFICATION,
      notification: notification,
      notificationType: notificationType
    }),
    onSetCarriers: (carriers) => dispatch({
      type: actionTypes.SET_CARRIERS,
      carriers: carriers
    }),
    onShowNewCarrier: (showNewCarrier) => dispatch({ type: actionTypes.SHOW_NEW_CARRIER, showNewCarrier: showNewCarrier })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewCarrier);



// WEBPACK FOOTER //
// ./src/components/UI/NewCarrier/NewCarrier.js